import * as React from 'react';
import classNames from 'classnames';

import { Link } from '../Link';
import { getLinksList } from './utils/getLinksList';

import * as styles from './LinksBlock.css';
import * as gridStyles from '../../utils/grid.css';

interface ILinksBlockProps {
  withAdditionalLinks: boolean;
  onLinkClick(event: React.MouseEvent<HTMLAnchorElement>, name: string): void;
}

export const LinksBlock: React.FC<ILinksBlockProps> = ({ withAdditionalLinks, onLinkClick }) => {
  const links = getLinksList({ withAdditionalLinks });

  return (
    <div className={classNames(styles['c-footer-links-container'], gridStyles['cg-col-24'])}>
      <ul className={styles['c-footer-links']}>
        {links.map(({ href, text, name, theme }, index) => (
          <li key={`links_block_${index}`} className={styles['c-footer-links-item']}>
            <Link href={href} theme={theme} onClick={event => onLinkClick(event, name)}>
              {text}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
